import { render } from "./TelegramImage.vue?vue&type=template&id=78950965"
import script from "./TelegramImage.vue?vue&type=script&lang=js"
export * from "./TelegramImage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__